import { focusPoints } from '@/mocks/home';

export default function FocusPoints() {
  return (
    <section id="focus" className="py-16 md:py-28 bg-background-100">
      <div className="w-full px-4 md:px-10">
        <div className="max-w-2xl mb-12">
          <span className="font-label text-xs tracking-[0.3em] text-primary-600">DISPUTE FOCUS</span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mt-3">
            争议焦点拆解
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-4 leading-relaxed">
            吵架的两个人，常常吵的根本不是同一件事。把争议拆成一个个具体焦点，你会更容易判断自己真正在意哪一条。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
          {focusPoints.map((point) => (
            <article
              key={point.title}
              className="group bg-background-50 border border-background-200/70 rounded-lg p-5 md:p-6 hover:border-primary-200 transition-colors"
            >
              <div className="flex items-start gap-4">
                <span className="w-11 h-11 shrink-0 flex items-center justify-center rounded-lg bg-primary-100 text-primary-700">
                  <i className={`${point.icon} text-xl`} />
                </span>
                <div>
                  <h3 className="font-heading text-lg font-semibold text-foreground-950">
                    {point.title}
                  </h3>
                  <p className="text-sm text-foreground-600 mt-2 leading-relaxed">{point.desc}</p>
                  <span className="inline-flex items-center gap-1.5 mt-4 text-xs text-secondary-700 font-label">
                    <i className="ri-chat-3-line" />
                    {point.count}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}